export enum WidgetTheme {
  LIGHT = 'light',
  BLUE = 'blue',
  GOLD = 'gold',
}
